var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content conta"},[_vm._m(0),_c('lista-certificados',{staticClass:"mt-5"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('span',[_c('i',{staticClass:"fas fa-bell"}),_vm._v(" Certificados")])])
}]

export { render, staticRenderFns }